import React from 'react';

export default function RecordIcon({ active = false, size = 22, ...props }) {
  const outerStroke = active ? '#ff3a3a' : 'rgba(255,58,58,0.7)';
  const innerStroke = active ? '#ff3a3a' : 'rgba(255,58,58,0.7)';
  const innerFill = active ? 'rgba(255,50,50,0.35)' : 'rgba(255,50,50,0.15)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Outer ring */}
      <circle cx="12" cy="12" r="9" stroke={outerStroke} strokeWidth="1.6" />
      {/* Inner filled circle */}
      <circle cx="12" cy="12" r="4" fill={innerFill} stroke={innerStroke} strokeWidth="1.4" />
    </svg>
  );
}
